module.exports = __webpack_public_path__ + "/login_ui/img/gh-7d9a6bec3efbc0b33a42dc0cbaef2ca7.svg";